var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { useMemo } from "react";
var counter = function () {
  var counts = {};
  return function (name) {
    counts[name] = ++counts[name] || 1;
    return counts[name];
  };
}();
var SvgStarInactive = function SvgStarInactive(props) {
  var key = useMemo(function () {
    return counter(SvgStarInactive);
  }, []);
  var getId = function getId(baseId) {
    return "".concat(baseId, "__").concat(key);
  };
  var getRef = function getRef(baseId) {
    return "#".concat(getId(baseId));
  };
  var getUrl = function getUrl(baseId) {
    return "url(".concat(getRef(baseId), ")");
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.15,
    height: 48,
    viewBox: "0 0 50.15 48",
    "aria-labelledby": props.title ? "SvgStarInactive__title" : undefined
  }, props), props.title && /*#__PURE__*/React.createElement("title", {
    id: "SvgStarInactive__title",
    lang: "en"
  }, props.title), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-star",
    "data-name": "Icon awesome-star",
    d: "M23.826,1.669,17.705,14.08l-13.7,2a3,3,0,0,0-1.659,5.118l9.908,9.655L9.915,44.489a3,3,0,0,0,4.349,3.159l12.252-6.44,12.252,6.44a3,3,0,0,0,4.349-3.159L40.774,30.85l9.908-9.655a3,3,0,0,0-1.659-5.118l-13.7-2L29.207,1.669a3,3,0,0,0-5.381,0Z",
    transform: "translate(-1.441 0.001)",
    fill: "#686a74"
  })));
};
export default SvgStarInactive;